import axios from "../utils/axios";

export function getDashboardInfo() {
  return axios.get("/Dashboard");
}
